import React from 'react'

import DropDown from '../../components/Input/DropDown'

import { useFormattedCategories, useLanguages } from '../../hooks'

import {
  jobFilterPosted,
  jobFilterPrices,
  jobFilterPriceTypes,
  jobSortOptions,
} from '../../constants/jobs'

const JobsFilters = ({ filters, onChange }) => {
  const categories = useFormattedCategories()
  const { formattedWorldLanguages } = useLanguages()

  const formattedCategories = [
    {
      value: '_',
      label: 'All Categories',
    },
    ...categories,
  ]
  const formattedLanguages = [
    {
      value: '_',
      label: 'All Languages',
    },
    ...formattedWorldLanguages,
  ]

  const handleChange = (name, value) => {
    onChange({
      ...filters,
      [name]: value,
    })
  }

  return (
    <div className="w-full flex flex-col items-start">
      <div className="w-full rounded-[10px] bg-[#FEEBDD] shadow-modal p-[20px]">
        <h3 className="text-xl font-bold text-primary-100">Filter</h3>

        <div className="mt-[20px] w-full flex flex-col items-start gap-y-[10px]">
          <div className="w-full">
            <span className="inline-block mb-[4px] text-sm font-medium text-primary-button">
              Category
            </span>

            <DropDown
              menuItems={formattedCategories}
              value={filters.job_category}
              setValue={(value) => handleChange('job_category', value)}
              className="!h-[44px]"
            />
          </div>

          <div className="w-full">
            <span className="inline-block mb-[4px] text-sm font-medium text-primary-button">
              Price
            </span>

            <DropDown
              menuItems={jobFilterPrices}
              value={filters.price}
              setValue={(value) => handleChange('price', value)}
              className="!h-[44px]"
            />
          </div>

          <div className="w-full">
            <span className="inline-block mb-[4px] text-sm font-medium text-primary-button">
              Posted
            </span>

            <DropDown
              menuItems={jobFilterPosted}
              value={filters.posted}
              setValue={(value) => handleChange('posted', value)}
              className="!h-[44px]"
            />
          </div>

          <div className="w-full">
            <span className="inline-block mb-[4px] text-sm font-medium text-primary-button">
              Job Type
            </span>

            <DropDown
              menuItems={jobFilterPriceTypes}
              value={filters.price_type}
              setValue={(value) => handleChange('price_type', value)}
              className="!h-[44px]"
            />
          </div>

          <div className="w-full">
            <span className="inline-block mb-[4px] text-sm font-medium text-primary-button">
              Language
            </span>

            <DropDown
              menuItems={formattedLanguages}
              value={filters.languages}
              setValue={(value) => handleChange('languages', value)}
              className="!h-[44px]"
            />
          </div>
        </div>
      </div>

      <div className="w-full rounded-[10px] bg-[#FEEBDD] shadow-modal p-[20px] mt-[24px]">
        <h3 className="text-xl font-bold text-primary-100">Sort by</h3>

        <div className="mt-[20px] w-full flex flex-col items-start">
          <DropDown
            menuItems={jobSortOptions}
            value={filters.ordering}
            setValue={(value) => handleChange('ordering', value)}
            className="!h-[44px]"
          />
        </div>
      </div>
    </div>
  )
}

export default JobsFilters
